import { ShieldAlert } from 'lucide-react';

import { PermissionDeniedDocsLink } from '@/components/error-handling/permission-denied-docs-link';
import { toast } from '@/components/ui/helpers/toast';
import {
  classifyApiError,
  getPermissionDeniedMessage,
} from '@/lib/helpers/api-errors/api-error';
import {
  ApiErrorClass,
} from '@/lib/types/api-error-enums';

const PERMISSION_TOAST_DURATION_MS = 15_000;
const PERMISSION_ICON_SIZE = 18;

export function toastApiError(error: unknown, fallbackMessage: string): void {
  if (classifyApiError(error) === ApiErrorClass.PERMISSION) {
    toast.error(getPermissionDeniedMessage(), {
      description: <PermissionDeniedDocsLink />,
      duration: PERMISSION_TOAST_DURATION_MS,
      icon: <ShieldAlert size={PERMISSION_ICON_SIZE} />,
    });
    return;
  }

  toast.error(fallbackMessage);
}
